<template>
  <div class="subscription-page">
    <v-container
      fluid
      :class="
        $vuetify.breakpoint.mdAndUp
          ? 'py-5 px-10'
          : '' && $vuetify.breakpoint.smAndUp
          ? 'py-2 px-2'
          : ''
      "
    >
      <v-row>
        <v-col cols="12" md="5" lg="4" class="order-md-2">
          <FetchSubscriptions :productType="['pro']" />
        </v-col>
        <v-col cols="12" md="7" lg="8" class="order-md-1">
          <!-- Plan comparison -->
          <v-card class="mb-6 comparison-card" elevation="2">
            <v-card-title
              class="text-h4 font-weight-medium white--text px-6 py-4"
            >
              <h1 class="text-h5 font-weight-bold text-center">
                {{ planTitle }}
              </h1>
            </v-card-title>
            <v-card-text class="px-6 py-4">
              <v-row>
                <v-col cols="12" md="6">
                  <h3 class="text-h6 font-weight-bold mb-4 primary--text">
                    Free Plan (Included)
                  </h3>
                  <v-list dense class="transparent">
                    <v-list-item
                      v-for="(feature, i) in freePlanFeatures"
                      :key="i"
                    >
                      <v-list-item-icon>
                        <v-icon color="success" class="mr-2"
                          >mdi-check-circle</v-icon
                        >
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">{{
                          feature
                        }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>

                <v-col cols="12" md="6">
                  <h3 class="text-h6 font-weight-bold mb-4 primary--text">
                    Features
                  </h3>
                  <v-list dense class="transparent">
                    <v-list-item
                      v-for="(feature, i) in proPlanFeatures"
                      :key="i"
                    >
                      <v-list-item-icon>
                        <v-icon color="primary" class="mr-2"
                          >mdi-star-circle</v-icon
                        >
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">{{
                          feature
                        }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Feature cards -->
          <v-row>
            <v-col cols="12" sm="6">
              <v-card class="mb-4 h-100 gradient-card" elevation="2">
                <v-card-title class="text-h5 font-weight-bold white--text">
                  <v-icon large color="white" class="mr-2"
                    >mdi-account-group</v-icon
                  >
                  Teams Workspace
                </v-card-title>
                <v-card-text class="white--text">
                  Collaborate seamlessly with your team using the Teams
                  workspace, effortlessly sharing bookmarks among colleagues.
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6">
              <v-card class="mb-4 h-100 gradient-card" elevation="2">
                <v-card-title class="text-h5 font-weight-bold white--text">
                  <v-icon large color="white" class="mr-2"
                    >mdi-folder-multiple</v-icon
                  >
                  Workspace Groups
                </v-card-title>
                <v-card-text class="white--text">
                  Organise your bookmark collections with groups, allowing for
                  seamless collaboration and sharing among unlimited members
                  within the Teams workspace.
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6">
              <v-card class="mb-4 h-100 gradient-card" elevation="2">
                <v-card-title class="text-h5 font-weight-bold white--text">
                  <v-icon large color="white" class="mr-2">mdi-brain</v-icon>
                  AI Recommended Websites
                </v-card-title>
                <v-card-text class="white--text">
                  Unlock personalised web experiences with our AI-driven
                  recommendations, tailored to your bookmarked sites using your
                  own OpenRouter API key. You can also organise your bookmarks
                  into logical categories automatically with AI.
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6">
              <v-card class="mb-4 h-100 gradient-card" elevation="2">
                <v-card-title class="text-h5 font-weight-bold white--text">
                  <v-icon large color="white" class="mr-2">mdi-rss</v-icon>
                  RSS Feeds Integration
                </v-card-title>
                <v-card-text class="white--text">
                  Stay updated with your favorite content through RSS feed
                  integration. Automatically fetch and organise updates from
                  your preferred websites and blogs.
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <!-- Tutorial Section -->
    <v-container fluid class="mt-10 white">
      <WorkspaceTutorial class="mt-8" />
    </v-container>

    <v-container
      class="pt-10"
      fluid
      style="padding:0;"
      :style="{ backgroundColor: $vuetify.theme.themes.light.lightgrey }"
    >
      <v-row>
        <v-col cols="12">
          <SubscriptionPricing />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import SubscriptionPricing from '@/components/layout/Subscription/SubscriptionPricing.vue'
import FetchSubscriptions from '@/components/stripe/FetchSubscriptions.vue'
import WorkspaceTutorial from '../../../../shared/components/workspace/WorkspaceTutorial.vue'

export default {
  name: 'PremiumSubscription',
  components: {
    FetchSubscriptions,
    SubscriptionPricing,
    WorkspaceTutorial
  },
  data() {
    return {
      planTitle: 'Pro Plan',
      freePlanFeatures: [
        'Unlimited Personal Bookmarks',
        'Workspace Groups (Up to 1 Group)',
        'Workspace Users (Unlimited)',
        'Create promo page',
        'Download our browser extension'
      ],
      proPlanFeatures: [
        'All Free Plan Features',
        'Workspace Groups (Up to 10 Groups)',
        'Workspace Users (Unlimited Users)',
        'RSS Feeds',
        'OpenRouter BYOK access for all AI features',
        'Priority Support'
      ]
    }
  },
  metaInfo: {
    title: 'Pro Subscription Plan',
    titleTemplate: '%s | LinkBook.io',
    meta: [
      {
        name: 'description',
        content:
          'Upgrade to LinkBook Pro Plan for enhanced bookmark management with up to 10 workspace groups, unlimited users, AI recommendations, and RSS feeds integration.'
      },
      {
        property: 'og:title',
        content: 'Pro Subscription Plan | LinkBook.io'
      },
      {
        property: 'og:description',
        content:
          'Take your bookmark organisation to the next level with LinkBook Pro. Enjoy AI recommended websites, RSS feed integration, and seamless team collaboration.'
      },
      {
        name: 'keywords',
        content:
          'pro bookmarks, workspace groups, bookmark management, RSS feeds, AI recommendations, team collaboration'
      }
    ]
  }
}
</script>

<style lang="scss" scoped>
.subscription-page {
  background: linear-gradient(135deg, #f5f5f5 0%, #fdffff 100%);
  min-height: 100vh;
  padding: 1rem 0;
}

.h-100 {
  height: 100%;
}

.gradient-card {
  &:nth-child(1),
  &:nth-of-type(1) {
    background: linear-gradient(45deg, #ff6b6b, #ff8e53);
  }
  &:nth-child(2),
  &:nth-of-type(2) {
    background: linear-gradient(45deg, #4e54c8, #8f94fb);
  }
  &:nth-child(3),
  &:nth-of-type(3) {
    background: linear-gradient(45deg, #11998e, #38ef7d);
  }
  &:nth-child(4),
  &:nth-of-type(4) {
    background: linear-gradient(45deg, #6b48ff, #8c6fff);
  }

  // Add hover effect
  transition: transform 0.3s ease;
  &:hover {
    transform: translateY(-5px);
  }

  // Ensure text is readable
  .v-card__title,
  .v-card__text {
    position: relative;
    z-index: 1;
  }

  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2) !important;
}

.comparison-card {
  background: linear-gradient(135deg, #2c3e50, #3498db);
  border-radius: 12px;
  transition: transform 0.3s ease;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2) !important;

  &:hover {
    transform: translateY(-3px);
  }

  .v-list {
    background: transparent !important;
  }

  .v-list-item {
    background: rgba(255, 255, 255, 0.95);
    border-radius: 8px;
    margin-bottom: 8px;
    transition: transform 0.2s ease;

    &:hover {
      transform: translateX(5px);
    }
  }

  .v-card__title {
    background: rgba(0, 0, 0, 0.1);
  }

  .v-card__text {
    background: white;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }
}
</style>
